// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExclamationCircleOutlinedSvg from "@fishx/icons-svg/es/asn/ExclamationCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleOutlinedSvg
  }));
};

ExclamationCircleOutlined.displayName = 'ExclamationCircleOutlined';
export default React.forwardRef(ExclamationCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExclamationCircleOutlined.js
// module id = 2634
// module chunks = 0